define([
	"dojo/_base/declare",
	"dojo/_base/event",
	"csi/heading/String",
	"csi/html",
	"csi/view"
], function(declare,event,StringRen,html,csiView) {

	return declare(StringRen, {
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: add link to source class if different than current class and is localized itself (in Classes table)
			var	b = this.inherited(arguments);
			var	node = ctx.getNode();
			
			if (node.LinkSourceType) {
				html.create("a", {
					"class": html.CSS_BROWSE,
					"onclick": function(e) {
						csiView.getView("LocaleClasses").selectClass(node.LinkSourceType);
						event.stop(e);
					}
				}, refNode.firstChild, html.POS_AROUND);
			}

			return b;
		}
	});
});